import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Tag } from 'antd';
import { Enumify } from "enumify-ts";
class VehicleHireStatus extends Enumify() {
    description;
    colour;
    static WITHHELD = new VehicleHireStatus("WITHHELD", "#f24b03");
    static ON_MARKET = new VehicleHireStatus("ON MARKET", "#f2930c");
    static ALLOCATED = new VehicleHireStatus("ALLOCATED", "#108ee9");
    static STARTED = new VehicleHireStatus("STARTED", "#2db7f5");
    static COMPLETED = new VehicleHireStatus("COMPLETED", "#87d068");
    static CANCELLED = new VehicleHireStatus("CANCELLED", "#aaa");
    static _ = VehicleHireStatus._closeEnum();
    constructor(description, colour) {
        super();
        this.description = description;
        this.colour = colour;
    }
    renderTag() {
        return _jsx(Tag, { color: this.colour, children: this.description });
    }
    static defaultFilters() {
        return ["WITHHELD", "ON_MARKET", "STARTED", "ALLOCATED", "COMPLETED"];
    }
    static filtersArray() {
        return VehicleHireStatus.values.map(t => {
            return { text: t.description, value: t.key };
        });
    }
}
export default VehicleHireStatus;
